<p-toast></p-toast>
<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <p-menubar [model]="tabItems" styleClass="ml-2 mr-2 " />
  </ng-template>
  <ng-template pTemplate="right">
    <p-button label="Сбросить" icon="pi pi-circle-off" styleClass="p-button-success mr-2" (onClick)="clearSavedSettings()"
              pTooltip="Сбросить внешний вид таблиц" tooltipPosition="top" [disabled]="false"></p-button>

    <p-button label="Export" icon="pi pi-upload" styleClass="p-button-info mr-2" pTooltip="Экспортировать отчет" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<p-accordion #home [multiple]="true" (onOpen)="onOpenTab1($event)" (activeIndexChange)="activeIndexChange($event)">
  <p-accordionTab [(selected)]="tabActiveState[0]" [cache]="cache">
    <ng-template pTemplate="header">
      <h3 id="anchorc" #anchorc>Курсы валют</h3>

      <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                (onClick)="copyClipBoard(siteUrl+'c/0');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                pTooltip="Скопировать '{{siteUrl+'c/0'}}' в буфер обмена" tooltipPosition="top">
      </p-button>

    </ng-template>
    <app-home-chart-currency-rates appStopAccordionHomeEnd [today]="today"></app-home-chart-currency-rates>
  </p-accordionTab>

  <ng-container *ngIf="canSeeFinanceResult">
    <p-accordionTab [(selected)]="tabActiveState[1]" [cache]="cache">
      <ng-template pTemplate="header">
        <h3 id="anchorf" #anchorf>Платежи</h3>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                  [cdkCopyToClipboard]="siteUrl+'f/0'" (onClick)="copyClipBoard(siteUrl+'f/0');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{siteUrl+'f/0'}}' в буфер обмена" tooltipPosition="top">
        </p-button>

        <p-button label="Огляд банківських транзакцій" icon="pi pi-inbox" styleClass="p-button-info ml-4"
                  (onClick)="displayBankPaymentReview = true; $event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Відкрити чергу банківських транзакцій, що очікують обробки" tooltipPosition="top">
        </p-button>

      </ng-template>
      <p-tabView #paymentInfo [(activeIndex)]="activePaymentIndex" (onChange)="handleMonChange($event)" appStopAccordionHomeEnd>
        <p-tabPanel tooltip="История оплат за {{dayPaymentsToSee}} дней, включая сегодня" [cache]="cache">
          <ng-template pTemplate="header">
            <h5 id="anchorf0">За {{dayPaymentsToSee}} дней</h5>

            <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                      (onClick)="copyClipBoard(siteUrl+'f/0');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                      [cdkCopyToClipboard]="siteUrl+'f/0'"
                      pTooltip="Скопировать '{{siteUrl+'f/0'}}' в буфер обмена" tooltipPosition="top">
            </p-button>

          </ng-template>
          <ng-template pTemplate="content">
            <app-home-chart-daily-payments *ngIf="activePaymentIndex==0" [dayPaymentsToSee]="dayPaymentsToSee" (onPeriodChange)="dayPaymentsToSee=$event"></app-home-chart-daily-payments>
          </ng-template>
        </p-tabPanel>

        <p-tabPanel *ngIf="departmentHead" tooltip="{{dayPerformanceToSee}} days invoicing performance" [cache]="cache">
          <ng-template pTemplate="header">
            <h5>За {{dayPerformanceToSee}} дней</h5>

            <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                      [cdkCopyToClipboard]="siteUrl+'f/1'" (onClick)="copyClipBoard(siteUrl+'f/1');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                      pTooltip="Скопировать '{{siteUrl+'f/1'}}' в буфер обмена" tooltipPosition="top">
            </p-button>

          </ng-template>
          <ng-template pTemplate="content">
            <app-home-chart-performance-sales *ngIf="activePaymentIndex==1" [today]="today" [days]="dayPerformanceToSee"></app-home-chart-performance-sales>
          </ng-template>
        </p-tabPanel>

        <p-tabPanel tooltip="История оплат за {{monthPaymentsToSee}} месяцев" [cache]="cache">
          <ng-template pTemplate="header">
            <h5>Тренд М2М</h5>

            <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                      [cdkCopyToClipboard]="siteUrl+'f/2'" (onClick)="copyClipBoard(siteUrl+'f/2');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                      pTooltip="Скопировать '{{siteUrl+'f/2'}}' в буфер обмена" tooltipPosition="top">
            </p-button>

          </ng-template>
          <ng-template pTemplate="content">
            <app-home-chart-monthly-payments *ngIf="activePaymentIndex==2" [monthPaymentsToSee]="monthPaymentsToSee" (onPeriodChange)="monthPaymentsToSee=$event"></app-home-chart-monthly-payments>
          </ng-template>
        </p-tabPanel>

        <p-tabPanel tooltip="Лучшие {{monthClientsPaymentsToSee}} клиентов за месяц" [cache]="cache">
          <ng-template pTemplate="header">
            <h5>Клиенты месяца</h5>

            <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                      [cdkCopyToClipboard]="siteUrl+'f/3'" (onClick)="copyClipBoard(siteUrl+'f/3');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                      pTooltip="Скопировать '{{siteUrl+'f/3'}}' в буфер обмена" tooltipPosition="top">
            </p-button>

          </ng-template>
          <ng-template pTemplate="content">
            <app-home-chart-monthly-client-payments *ngIf="activePaymentIndex==3" [top]="monthClientsPaymentsToSee" [date]="today"></app-home-chart-monthly-client-payments>
          </ng-template>
        </p-tabPanel>

        <p-tabPanel *ngIf="departmentHead" tooltip="Продажи помесячно/квартально за период в разрезе клиентов (корпоратив или розница)" [cache]="cache">
          <ng-template pTemplate="header">
            <h5>За период в разрезе клиентов</h5>

            <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                      [cdkCopyToClipboard]="siteUrl+'f/4'" (onClick)="copyClipBoard(siteUrl+'f/4');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                      pTooltip="Скопировать '{{siteUrl+'f/4'}}' в буфер обмена" tooltipPosition="top">
            </p-button>

          </ng-template>

          <ng-template pTemplate="content">
            <app-home-chart-annual-sales [today]="today" [days]="dayPerformanceToSee"></app-home-chart-annual-sales>
          </ng-template>
        </p-tabPanel>

      </p-tabView>
    </p-accordionTab>

  </ng-container>

  <p-accordionTab [(selected)]="tabActiveState[2]" [cache]="cache">
    <ng-template pTemplate="header">
      <h3 id="anchori" #anchori>Счета</h3>

      <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                [cdkCopyToClipboard]="siteUrl+'i/0'" (onClick)="copyClipBoard(siteUrl+'i/0');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                pTooltip="Скопировать '{{siteUrl+'i/0'}}' в буфер обмена" tooltipPosition="top">
      </p-button>

    </ng-template>
    <p-tabView #ordersInfo [(activeIndex)]="ordersActiveIndex" appStopAccordionHomeEnd>
      <p-tabPanel rightIcon="pi pi-bookmark" [cache]="cache" tooltip="Новые счета за сегодня">
        <ng-template pTemplate="header">
          <h5>{{invTabName1}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'i/0'" (onClick)="copyClipBoard(siteUrl+'i/0');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'i/0'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-home-recent-orders-list [today]="today" [clean]="clean" *ngIf="tabActiveState[2] && (ordersActiveIndex == 0)"></app-home-recent-orders-list>
      </p-tabPanel>

      <p-tabPanel rightIcon="pi pi-bookmark" [cache]="cache" tooltip="Актуальные счета с активным резервом товаров">
        <ng-template pTemplate="header">
          <h5>{{invTabName2}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'i/1'" (onClick)="copyClipBoard(siteUrl+'i/1');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'i/1'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-home-active-orders-list [today]="today" [clean]="clean" *ngIf="tabActiveState[2] && (ordersActiveIndex == 1)"></app-home-active-orders-list>
      </p-tabPanel>

      <p-tabPanel [cache]="cache" rightIcon="pi pi-money-bill" tooltip="Оплаченные за прошедшие сутки счета">
        <ng-template pTemplate="header">
          <h5>{{invTabName3}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'i/2'" (onClick)="copyClipBoard(siteUrl+'i/2');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'i/2'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-home-paid-orders-list [today]="today" [clean]="clean" *ngIf="tabActiveState[2] && (ordersActiveIndex == 2)"></app-home-paid-orders-list>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [cache]="cache" rightIcon="pi pi-shopping-cart" tooltip="Оплаченные счета, ожидающие отгрузки">
        <ng-template pTemplate="header">
          <h5>{{invTabName4}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'i/3'" (onClick)="copyClipBoard(siteUrl+'i/3');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'i/3'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-home-not-shipped-orders-list [today]="today" [clean]="clean" *ngIf="tabActiveState[2] && (ordersActiveIndex == 3)"></app-home-not-shipped-orders-list>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [cache]="cache" rightIcon="pi pi-clock" tooltip="Просроченные счета">
        <ng-template pTemplate="header">
          <h5>{{invTabName5}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'i/4'" (onClick)="copyClipBoard(siteUrl+'i/4');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'i/4'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-home-not-paid-orders-list [today]="today" [clean]="clean" *ngIf="tabActiveState[2] && (ordersActiveIndex == 4)"></app-home-not-paid-orders-list>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </p-accordionTab>

  <p-accordionTab [(selected)]="tabActiveState[3]" [cache]="cache">
    <ng-template pTemplate="header">
      <h3 id="anchorp" #anchorp>Товары</h3>

      <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                [cdkCopyToClipboard]="siteUrl+'p/0'" (onClick)="copyClipBoard(siteUrl+'p/0');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                pTooltip="Скопировать '{{siteUrl+'p/0'}}' в буфер обмена" tooltipPosition="top">
      </p-button>

    </ng-template>
    <p-tabView [(activeIndex)]="activeItemIndex" appStopAccordionHomeEnd>
      <p-tabPanel [cache]="cache">
        <ng-template pTemplate="header">
          <h5 id="anchorp1">{{itemTabName1}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'p/1'" (onClick)="$event.stopPropagation();copyClipBoard(siteUrl+'p/1');"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'p/1'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-product-list-paid></app-product-list-paid>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel [cache]="cache">
        <ng-template pTemplate="header">
          <h5 id="anchorp2">{{itemTabName2}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'p/2'" (onClick)="$event.stopPropagation();copyClipBoard(siteUrl+'p/2');"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'p/2'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-product-part-list-paid></app-product-part-list-paid>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel [cache]="cache">
        <ng-template pTemplate="header">
          <h5 id="anchorp3">{{itemTabName3}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'p/3'" (onClick)="$event.stopPropagation();copyClipBoard(siteUrl+'p/3');"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'p/3'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-product-part-list-by-doc></app-product-part-list-by-doc>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel [cache]="cache">
        <ng-template pTemplate="header">
          <h5 id="anchorp4">{{itemTabName4}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'p/4'" (onClick)="$event.stopPropagation();copyClipBoard(siteUrl+'p/4')"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'p/4'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-product-list-invoiced></app-product-list-invoiced>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [cache]="cache">
        <ng-template pTemplate="header">
          <h5 id="anchorp5">{{itemTabName5}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'p/5'" (onClick)="$event.stopPropagation();copyClipBoard(siteUrl+'p/5');"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'p/5'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <app-product-list-in-transit></app-product-list-in-transit>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [cache]="cache">
        <ng-template pTemplate="header">
          <h5 id="anchorp6">{{itemTabName6}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true" size="small"
                    [cdkCopyToClipboard]="siteUrl+'p/6'" (onClick)="$event.stopPropagation();copyClipBoard(siteUrl+'p/5');"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{siteUrl+'p/6'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <ng-template pTemplate="content">
          <!--// Here the placeholder for new component
          // to show products that have arrived to stock during the recent days
          //
          // <app-product-list-arrived></app-product-list-arrived>-->
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </p-accordionTab>

  <ng-container *ngIf="canSeeAgentDashboard">
    <p-accordionTab [(selected)]="tabActiveState[4]" [cache]="cache">
      <ng-template pTemplate="header">
        <h3 id="anchora" #anchora>Agent</h3>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                  [cdkCopyToClipboard]="siteUrl+'a/0'" (onClick)="copyClipBoard(siteUrl+'a/0');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{siteUrl+'a/0'}}' в буфер обмена" tooltipPosition="top">
        </p-button>

      </ng-template>
      <app-agent-dashboard appStopAccordionHomeEnd></app-agent-dashboard>
    </p-accordionTab>

    <p-accordionTab [(selected)]="tabActiveState[5]" [cache]="cache">
      <ng-template pTemplate="header">
        <h3 id="anchoraspam" #anchoraspam>Спам</h3>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-4" [outlined]="true"
                  [cdkCopyToClipboard]="siteUrl+'s/0'" (onClick)="copyClipBoard(siteUrl+'s/0');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{siteUrl+'s/0'}}' в буфер обмена" tooltipPosition="top">
        </p-button>

      </ng-template>
      <app-agent-spam-queue appStopAccordionHomeEnd></app-agent-spam-queue>
    </p-accordionTab>
  </ng-container>
</p-accordion>
<p-scrollTop />

<app-agent-bank-payment-review *ngIf="canSeeFinanceResult" [display]="displayBankPaymentReview" (displayChange)="displayBankPaymentReview = $event"></app-agent-bank-payment-review>
